import {RouteRecordRaw} from "vue-router";
import Lista from "../pages/autores/Autores.vue";
import FormularioAutores from "../pages/autores/FormularioAutores.vue";

export const Autores: RouteRecordRaw[] = [
    {name: 'autores', path: '/autores', meta: {title: 'Autores'}, component: Lista},
    {name: 'autores.nuevo', path: '/autores/nuevo', meta: {title: 'nuevo autor'}, component: FormularioAutores},
    {name: 'autores.editar', path: '/autores/:id', meta: {title: 'Editar autor'}, component: FormularioAutores},
];